import type { Note } from "@gbougakov/brief-ts";
import { TagChips } from "./TagChips";
import { VoiceNoteCard } from "./VoiceNoteCard";

interface NoteCardProps {
  note: Note;
}

function formatTime(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
}

export function NoteCard({ note }: NoteCardProps) {
  if (note.isVoiceMessage) {
    return <VoiceNoteCard note={note} />;
  }

  return (
    <div className="bg-surface-container-high rounded-2xl overflow-hidden p-4 flex flex-col gap-3">
      <p className="text-base leading-6 text-on-surface whitespace-pre-wrap break-words">
        {note.content}
      </p>
      <TagChips noteId={note.id} />
      <span className="text-base leading-4 text-outline self-start">
        {formatTime(note.createdAt)}
      </span>
    </div>
  );
}
